
const yuklemeTuruOptions = [
    {
        value: false,
        text: "FTL(Komple Araç)",
    },
    {
        value: true,
        text: "LTL(Parsiyel)"
    }
]


export default yuklemeTuruOptions